import * as React from 'react';
import { emailPattern, emailPatternErrorMessage } from '../../core/constants';
import Input from './Input';

const EmailField = (props: Props) => {
	return (
		<Input
			label={props.label ?? 'Email'}
			name={props.name ?? 'email'}
			type={props.type ?? 'email'}
			required={props.required ?? false}
			validate={props.validate}
			pattern={emailPattern}
			patternErrorMessage={emailPatternErrorMessage}
			startAdornment={props.startAdornment}
			endAdornment={props.endAdornment}
			disabled={props.disabled ?? false}
			onPaste={props.onPaste}
		/>
	);
};

interface Props {
	startAdornment?: React.ReactNode;
	endAdornment?: React.ReactNode;
	disabled?: boolean;
	label?: string;
	name?: string;
	validate?: unknown;
	required?: boolean;
	type?: string;
	onPaste?: (e: React.ClipboardEvent) => void;
}

export default EmailField;
